import {
  ALPHANUMERIC_REGEX,
  MIN_LETTERS_REGEX,
  NO_CONSECUTIVE_REGEX,
} from "libraries/yup/regex";
import { object, string } from "yup";

export const playerSchema = object({
  playerAlias: string()
    .min(3, "El alias debe tener al menos 3 caracteres")
    .max(50, "El alias no puede tener más de 50 caracteres")
    .matches(ALPHANUMERIC_REGEX, "El nombre debe ser alfanumérico")
    .matches(MIN_LETTERS_REGEX(1), "El alias debe contener al menos 1 letra")
    .matches(
      NO_CONSECUTIVE_REGEX,
      "El alias no debe tener caracteres especiales o espacios consecutivos",
    )
    .required("El alias es requerido"),
  sessionId: string().required(),
  containerId: string().required(),
}).noUnknown();
